module.exports = __webpack_public_path__ + "img/countdown.057c9585.png";